import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  fetchTradeFees,
} from '../../actions';

class Crypto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPair: '',
    };
    this.makerTakerTiers = this.makerTakerTiers.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchTradeFees());
  }

  componentDidUpdate() {
    const { dispatch, pair } = this.props;
    const { currentPair } = this.state;

    if (currentPair !== pair) {
      this.setState({ currentPair: pair });
      dispatch(fetchTradeFees());
    }
  }

  makerTakerTiers(feeMaker, feeTaker) {
    const { volume30 } = this.props;

    let currentTraderTier;
    let currentMakerData;
    let currentTakerData;

    // Find next and current tiers
    if ((feeMaker && feeTaker) && (volume30 && volume30[0] && volume30[0].value)) {
      currentTraderTier = feeMaker.findIndex(x => x.bound > volume30[0].value);
      if (currentTraderTier < 0 || currentTraderTier > (feeMaker.length - 1)) {
        currentTraderTier = feeMaker.length - 1;
      }
    }

    // if no volume30 show tier 0
    if (!volume30 || (volume30 && volume30.length < 1)) {
      currentTraderTier = 0;
      currentMakerData = feeMaker[0];
      currentTakerData = feeTaker[0];
    }

    // Get current maker/taker data
    if (currentTraderTier >= 0) {
      currentMakerData = feeMaker[currentTraderTier];
      currentTakerData = feeTaker[currentTraderTier];
    }

    return (
      <div className="osi-c">
        <div className="osi-i">
          <div className="osi-i-n">Maker Fee:</div>
          <div className="osi-i-t">
            {currentMakerData ? (
              currentMakerData.percentage + '%'
            ) : (
              ''
            )}
          </div>
        </div>
        <div className="osi-i">
          <div className="osi-i-n">Taker Fee:</div>
          <div className="osi-i-t">
            {currentTakerData ? (
              currentTakerData.percentage + '%'
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { balance, ohlc, exchA, exchB, tradePairs, pair, setPair, fees, getPairAssets } = this.props;

    const exchangesLoop = tradePairs && tradePairs.map((item, index) => {
      return (
        <option key={index} value={item.pair}>{item.name}</option>
      );
    });

    let aPending;
    let aSettled;
    let bPending;
    let bSettled;
    let aAvailable;
    let bAvailable;
    let tempaAvailable;
    let tempbAvailable;

    let assetAData;
    let assetAPending;
    let assetASettled;
    let assetAAvailable;
    let assetBData;
    let assetBPending;
    let assetBSettled;
    let assetBAvailable;
    let pairFees;

    let feeTaker;
    let feeMaker;

    const pairAssets = getPairAssets(pair);
    let assetA;
    let assetB;
    if (pairAssets) {
      assetA = pairAssets.exchA;
      assetB = pairAssets.exchB;
    }
    if ((balance && balance.data && balance.data.length) && (assetA && assetB)) {
      assetAData = balance.data.filter(function(item) {
        return item.handle === assetA;
      });
      assetBData = balance.data.filter(function(item) {
        return item.handle === assetB;
      });

      if (assetAData && assetAData.length) {
        assetAPending = assetAData.find(function(item) {
          return item.type === 'PENDING';
        });
        assetASettled = assetAData.find(function(item) {
          return item.type === 'SETTLED';
        });
        assetAAvailable = assetAData.find(function(item) {
          return item.type === 'AVAILABLE';
        });
      }
      if (assetBData && assetBData.length) {
        assetBPending = assetBData.find(function(item) {
          return item.type === 'PENDING';
        });
        assetBSettled = assetBData.find(function(item) {
          return item.type === 'SETTLED';
        });
        assetBAvailable = assetBData.find(function(item) {
          return item.type === 'AVAILABLE';
        });
      }
    }
    if (balance && balance.data && balance.data.length) {
      const hasAPending = assetAPending && assetAPending.quantity;
      const hasASettled = assetASettled && assetASettled.quantity;
      const hasBPending = assetBPending && assetBPending.quantity;
      const hasBSettled = assetBSettled && assetBSettled.quantity;

      if (pair && hasAPending && hasASettled && hasBPending && hasBSettled) {
        aPending = assetAPending.quantity;
        aSettled = assetASettled.quantity;
        bPending = assetBPending.quantity;
        bSettled = assetBSettled.quantity;
        tempaAvailable = assetAAvailable.quantity;
        tempbAvailable = assetBAvailable.quantity;
      }

      if ((aPending != null) && (bPending != null) && (aSettled != null) && (bSettled != null)) {
        aAvailable = (aSettled - aPending).toFixed(8);
        bAvailable = (bSettled - bPending).toFixed(8);
      }

      // TODO
      // Replace this once api change sorted
      if (tempaAvailable) {
        aAvailable = tempaAvailable;
      }
      if (tempbAvailable) {
        bAvailable = tempbAvailable;
      }
      //
    }

    if (fees && fees.length) {
      pairFees = fees.filter(function(item) {
        return item.pair === pair;
      });

      feeTaker = pairFees.filter(function(item) {
        return item.type === 'TAKER';
      });
      feeMaker = pairFees.filter(function(item) {
        return item.type === 'MAKER';
      });
    }

    return (
      <div className="cell panel small-12 medium-12 large-12 order-sel-con">
        <div className="order-sel">
          <select id="exchange" onChange={setPair} value={pair}>
            {exchangesLoop}
          </select>
        </div>
        <div className="order-sel-info">
          {(feeMaker && feeTaker) ?
            this.makerTakerTiers(feeMaker, feeTaker) : null
          }
          <div className="osi-c">
            <div className="osi-i">
              <div className="osi-i-n">
                <span>{exchA} </span>
                total balance:
              </div>
              <div className="osi-i-t">{aSettled || '0'}</div>
            </div>
            <div className="osi-i">
              <div className="osi-i-n">
                <span>{exchA} </span>
                available balance:
              </div>
              <div className="osi-i-t">{aAvailable || '0'}</div>
            </div>
          </div>

          <div className="osi-c">
            <div className="osi-i">
              <div className="osi-i-n">
                <span>{exchB} </span>
                total balance:
              </div>
              <div className="osi-i-t">{bSettled || '0'}</div>
            </div>
            <div className="osi-i">
              <div className="osi-i-n">
                <span>{exchB} </span>
                available balance:
              </div>
              <div className="osi-i-t">{bAvailable || '0' }</div>
            </div>
          </div>

          <div className="osi-c">
            <div className="osi-i">
              <div className="osi-i-n">Low (24h):</div>
              <div className="osi-i-t">{ohlc.length ? ohlc[0].low : '0'}</div>
            </div>
            <div className="osi-i">
              <div className="osi-i-n">High (24h):</div>
              <div className="osi-i-t">{ohlc.length ? ohlc[0].high : '0'}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  errors: state.user.errors,
  balance: state.balance.balance,
  ohlc: state.ohlc.ohlc,
  fees: state.fees.fees,
  volume30: state.fees.volume30,
});

export default connect(mapStateToProps)(Crypto);
